import { Fragment } from "react";
import { LHeader } from "@/components";
import { composeContainers } from "@/utils/composeContainers";
import { withData } from "./containers/withData";
import { ViewProps, ContainerProps } from "./types";
import clsx from "clsx";
import CRMPermissionProvider from "@/providers/CRMPermissionProvider";
export default composeContainers<ViewProps, ContainerProps>({
  containers: [withData],
  component: ({
    children,
    isCrm,
    noSpacing = false,
    bgLight = false,
    ...props
  }: ViewProps) => (
    <Fragment>
      {!isCrm && <LHeader {...props} />}
      <div
        className={clsx([!noSpacing && "px-5 mt-4", bgLight && "bg-lightblue"])}
      >
        {isCrm && <CRMPermissionProvider>{children}</CRMPermissionProvider>}
        {!isCrm && children}
      </div>
    </Fragment>
  ),
});
